<div [hidden]="(profileState | async).audit !== null
  && (profileState | async).audit.status !== 0
  && (profileState | async).audit.bio !== undefined
  && (profileState | async).audit.bio.mention_count !== undefined
  && (profileState | async).audit.bio.mention_count === 0">
  <ng-content></ng-content>
</div>
<div *ngIf="
  (profileState | async).audit !== null
  && (profileState | async).audit.status !== 0
  && (profileState | async).audit.bio !== undefined
  && (profileState | async).audit.bio.mention_count !== undefined
  && (profileState | async).audit.bio.mention_count === 0
  "
>
  <div *ngIf="type() === 'chart'"
       class="text-center px-5 pb-5"
       [ngClass]="(name() === 'Engagement rate') ? 'pt-3' : 'pt-5'"
  >
    <h6 class="font-weight-normal">
      {{name()}} chart is not available because
      <a href="{{'https://www.instagram.com/' + (profileState | async).audit.profile}}" target="_blank" class="link">&#64;{{ (profileState | async).audit.profile }}</a>
      did not add a post within last 30 days
    </h6>
  </div>
  <div *ngIf="type() === 'value'">
    <h5 class="mb-1">
      No data
      <a data-tooltip="Data is not available due to lack of posts within last 30 days">
        <img class="icon-info" src="./assets/images/icons/info.png"/>
      </a>
    </h5>
  </div>

</div>

